export { default } from "./PermissionsPageLayout";
